import type { TrackFunction } from "@similarweb/contact-us";

import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

export default function createSuggestedQuickActionsTrackingService(track: TrackFunction) {
    function trackEvent(action: string, eventName: string, eventSubName?: string, eventSubSubName?: string): void {
        const event: string = createTrackingEventName(eventName, eventSubName, eventSubSubName);

        track("quick actions", action, event);
    }

    function trackClickEvent(eventName: string, eventSubName?: string, eventSubSubName?: string): void {
        trackEvent("click", eventName, eventSubName, eventSubSubName);
    }

    return {
        trackClickQuickAction(type: string): void {
            trackClickEvent(type);
        },
    };
}
